import { render, staticRenderFns } from "./TagRow.vue?vue&type=template&id=27a7e067"
import script from "./TagRow.vue?vue&type=script&lang=ts"
export * from "./TagRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports